export default __webpack_public_path__ + "static/media/kuchnia.5deff9e7.jpg";